import { ro } from 'date-fns/locale';
import { NavItem } from './nav-item/nav-item';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class NavItemService {

  public getNav(data?: any) {
    return [
      {
        displayName: 'nav.home',
        iconName: 'home',
        route: '/dashboards/dashboard1',
        roles: data.dashboard.roles
      },
      {
        navCap: 'nav.travels.travels',
        roles: data.travels.roles
      },
      {
        displayName: 'nav.travels.nationals',
        iconName: 'pin',
        route: 'travels/nationals',
        roles: data.travels.nationals.roles
      },
      {
        displayName: 'nav.travels.internationals',
        iconName: 'plane-departure',
        route: 'travels/internationals',
        roles: data.travels.internationals.roles
      },
      {
        displayName: 'nav.travels.customers',
        iconName: 'user-star',
        route: 'travels/customers',
        roles: data.travels.customers.roles
      },
      {
        navCap: 'nav.quotes.quotes',
        roles: data.quotes.roles
      },
      {
        displayName: 'nav.quotes.preQuotes',
        iconName: 'checklist',
        route: 'quotes/pre-quotes',
        roles: data.quotes.preQuotes.roles
      },
      {
        displayName: 'nav.quotes.quotes2',
        iconName: 'pinned',
        route: 'quotes',
        roles: data.quotes.roles,
      },
      {
        navCap: 'nav.alexaReservations.alexaReservations',
        roles: data.alexaReservations.roles
      },
      {
        displayName: 'nav.alexaReservations.list',
        iconName: 'microphone',
        route: 'alexa-reservations',
        roles: data.alexaReservations.roles
      },
      {
        navCap: 'nav.clients.clients',
        roles: data.clients.roles
      },
      {
        displayName: 'nav.clients.list',
        iconName: 'checklist',
        route: 'clients',
        roles: data.clients.roles
      },
      {
        navCap: 'nav.tours.tours',
        roles: data.tours.roles
      },
      {
        displayName: 'nav.tours.list',
        iconName: 'pinned',
        route: 'tours',
        roles: data.tours.roles
      },
      {
        navCap: 'nav.employees.employees',
        roles: data.employee.roles
      },
      {
        displayName: 'nav.employees.list',
        iconName: 'list',
        route: 'employees',
        roles: data.employee.roles
      },
      {
        navCap: 'nav.accounting.accounting',
        roles: data.accounting.roles
      },
      {
        displayName: 'nav.accounting.proofIncome',
        iconName: 'brand-ctemplar',
        route: 'accounting/proof-income',
        roles: data.accounting.proofIncome.roles
      },
      {
        displayName: 'nav.accounting.wordOrders',
        iconName: 'brand-databricks',
        route: 'accounting/word-orders',
        roles: data.accounting.wordOrders.roles
      },
      {
        navCap: 'nav.reports.reports',
        roles: data.reports.roles
      },
      {
        displayName: 'nav.reports.cashClosing',
        iconName: 'brand-ctemplar',
        route: 'reports',
        roles: data.reports.cashClosing.roles
      },
      {
        navCap: 'nav.settings.settings',
        roles: data.settings.roles
      },
      {
        displayName: 'nav.settings.roles',
        iconName: 'note',
        route: 'settings/roles',
        roles: data.settings.roless.roles
      },
      {
        displayName: 'nav.settings.permissions',
        iconName: 'lock-access',
        route: 'settings/permissions',
        roles: data.settings.permissions.roles
      },
      {
        displayName: 'nav.settings.providers',
        iconName: 'ticket',
        route: 'settings/providers',
        roles: data.settings.providers.roles
      },
      {
        displayName: 'nav.settings.transports',
        iconName: 'truck',
        route: 'settings/transports',
        roles: data.settings.transports.roles
      },
      {
        displayName: 'notifications.config.menu',
        iconName: 'bell-cog',
        route: 'settings/notifications',
        roles: data.settings.notifications.roles
      }
    ]
  }
}